const fontWeightBold = 'var(--fontWeightBold, 700)'
import styled from 'astroturf/react'
import { useSelector } from 'react-redux'

import { chargeCapturedSelector } from 'selectors/payment'
import { notificationTypeSelector } from 'selectors/scheduling'
import { useI18n } from 'locales'
import _Message from "payment_message-Message.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/confirmation/payment_message.js?styleId=Message";


const Message = /*#__PURE__*/styled('div', null, {
  displayName: "Message",
  styles: _Message
})

const useGetMessage = (type, hasCapturedCharge) => {
  const { i18n } = useI18n()
  switch (type) {
    case 'calendar': {
      if (!hasCapturedCharge) return i18n.t('booking.templates.calendar_invitation_sent')
      return i18n.t('booking.confirmation.calendar_payment')
    }
    case 'email': {
      if (!hasCapturedCharge) return null
      return i18n.t('booking.confirmation.email_payment')
    }
    default: {
      return null
    }
  }
}

const PaymentMessage = () => {
  const type = useSelector(notificationTypeSelector)
  const hasCapturedCharge = useSelector(chargeCapturedSelector)
  const message = useGetMessage(type, hasCapturedCharge)

  if (!message) return null

  return (
    <Message>
      {message}
    </Message>
  )
}

export default PaymentMessage
